interface ProjectCardBySkillProps {
    projectName: string;
    employeeGoalCount: number;
    employeeActualHours: number;
}

const ProjectCardBySkill = ({ projectName, employeeGoalCount, employeeActualHours }: ProjectCardBySkillProps) => {
    return (
        <div className="bg-surface-bg-primary border border-surface-border rounded-lg p-4 hover:shadow-sm transition-shadow user-project-card">
            <div className="flex items-start justify-between gap-4">
                <div className="flex items-start gap-3 flex-1">
                    <div className="w-10 h-10  border-2 border-surface-border flex items-center justify-center mt-1 inner-user-project-card">
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
                            <polyline points="9 22 9 12 15 12 15 22" />
                        </svg>
                    </div>
                    <div className="flex-1">
                        {/* Line 1: Project Name */}
                        <div className="mb-2">
                            <h4 className="text-sm font-semibold">{projectName}</h4>
                        </div>
                        {/* Line 2: Goal Count and Actual Hours */}
                        <div className="flex items-center gap-3 text-xs text-text-text-secondary flex-wrap">
                            <span className="flex items-center gap-1">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="22 4 12 14.01 9 11.01" />
                                </svg>
                                {employeeGoalCount} {employeeGoalCount === 1 ? 'Goal' : 'Goals'}
                            </span>
                            <span className="flex items-center gap-1">
                                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="10" />
                                    <polyline points="12 6 12 12 16 14" />
                                </svg>
                                {employeeActualHours.toFixed(1)}h
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProjectCardBySkill;
